import React, { useState, useEffect, useCallback } from "react";
import {
  GoogleOAuthProvider,
  GoogleLogin,
  useGoogleLogin,
} from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Illustration from "../images/Illustration.svg";
import IconFacebook from "../images/icon-fb.svg";
import IconApple from "../images/icon-apple.svg";
// import Logo from '../images/logo.png';
import IconMail from "../images/iconMail.svg";
import IconLock from "../images/iconLock.svg";
import IconLGoogle from "../images/iconGLogin.svg";
import { Link } from "react-router-dom";
import LogoStolity from "../images/prelogin-img/logo-stolity.svg";
import NewLogo from "../images/NewLogo.svg";
import FA from "../images/Facebook.png";
import GOO from "../images/google.png";
import APL from "../images/apple.png";
import { motion } from "framer-motion";
import { ReactComponent as PasswordShow } from "../images/icon-eye.svg";
import { ReactComponent as PasswordHide } from "../images/icon-eye-hide.svg";
import { ChakraProvider, Stack, useToast } from "@chakra-ui/react";

import { useDispatch, useSelector } from "react-redux";
import { setGoogleAuth } from "../store/fileSlicer"; // adjust path as needed




const slides = [
  {
    title: "Upload Files",
    text: "Store up to 5GB data in a centralised location for easy access and management.",
  },
  { title: "Fast Access", text: "Experience quicker uploads for every file type — faster, smoother, better." },
  {
    title: "Generate Link",
    text: "Generate links and shorten them for efficient sharing of files.",
  },
  {
    title: "Generate QR code",
    text: "Generate and scan the QR code to download all files with one click.",
  },
  {
    title: "Share Securely",
    text: "Securely share files to multiple people from any location.",
  },
];

const Login = () => {
  //Anurag Imports
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const clientid = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
  const [currentSlide, setCurrentSlide] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
  }, []);

useEffect(() => {
  // Reset Google Auth state on login page load
  dispatch(setGoogleAuth(false));
  console.log("google value reset to false")
}, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const handleEmail = (event) => {
    setEmail(event.target.value);
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (event.target.value === "") {
      setEmailError("Email is required");
    } else if (!emailPattern.test(event.target.value)) {
      setEmailError("Invalid email address");
    } else {
      setEmailError(""); // Clear the error message if valid
    }
  };

  const handlePass = (event) => {
    setPassword(event.target.value);

    // Password validation criteria
    if (event.target.value.length < 6) {
      setPasswordError("Password must be at least 6 characters long");
    } else if (!/[0-9]/.test(event.target.value)) {
      setPasswordError("Password must contain at least one number");
    } else {
      setPasswordError(""); // Clear the error message if valid
    }
  };

  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  const handleInputFocus = (e) => {
    const targetName = e.target.name;
    document.querySelector(`.f-label-${targetName}`).classList.add("f-up");
  };

  const handleInputBlur = (e) => {
    const { name, value } = e.target;
    const label = document.querySelector(`.f-label-${name}`);
    if (value === "") {
      label.classList.remove("f-up");
    }
  };

  const navigate = useNavigate();

  // LOGIN ANIMATION
  const [buttonClicked, setButtonClicked] = useState(false);
  const [spanExpanded, setSpanExpanded] = useState(false);

  useEffect(() => {
    if (buttonClicked) {
      const buttonTimeout = setTimeout(() => {
        setButtonClicked(false);
        navigate("/Files"); // Navigate after button animation
      }, 1500);
      return () => clearTimeout(buttonTimeout);
    }
  }, [buttonClicked, navigate]);

  useEffect(() => {
    if (spanExpanded) {
      const spanTimeout = setTimeout(() => setSpanExpanded(false), 2000);
      return () => clearTimeout(spanTimeout);
    }
  }, [spanExpanded]);

  //Login code
  const handleReq = useCallback(async () => {
    try {
      const res = await axios.post(
        `${apiEndPoint}login-user`,
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
        
      // Only start animation if we get a successful response (200)
      if (res.status === 200) {
        // Start the loader animation
        setButtonClicked(true);
        setSpanExpanded(true);
        
        // Extract all data first
        const responseData = res.data;
        const accessToken = responseData.accessToken;
        const userData = responseData.userData;
        
        // Clear and set session storage
        sessionStorage.clear();
        sessionStorage.setItem("userData", JSON.stringify(responseData));
        sessionStorage.setItem("number", accessToken.toString());
        sessionStorage.setItem("email", userData.email.toString());
        sessionStorage.setItem("name", userData.name.toString());
        
        // Only set contact if it exists
        if (userData.contact) {
          sessionStorage.setItem("num", userData.contact.toString());
        }
        
        // Handle avatar with fallback
        sessionStorage.setItem(
          "avatar",
          userData.userAvatar?.toString() || "https://nodeserver-filestorage.s3.ap-south-1.amazonaws.com/Avatars/Frame+2085661548.svg"
        );

        // Show success toast
        // showToast("success", "You have logged in successfully!");
        setError(null); // Clear any previous errors
        
        // Navigation will be handled by the animation timeout
      }
    } catch (error) {
      console.error("Login error:", error); // Log the full error for debugging
      setError(
        error.response?.data?.message || "An error occurred during login"
      );
      showToast("error", error.response?.data?.message || "Some error has occurred while logging you in!");
    }
  }, [email, password, navigate]);

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission
    if (emailError == "" && passwordError == "") {
      handleReq();
    }
    // Call the handleReq function
  };

  const pathVariants = {
    hidden: { pathLength: 0, fill: "" },
    animate: {
      scale: [1, 2, 2, 1, 1],
      rotate: [0, 0, 180, 180, 0],
      borderRadius: ["0%", "0%", "50%", "50%", "0%"],
    },
    transition: {
      duration: 2,
      ease: "easeInOut",
      times: [0, 0.2, 0.5, 0.8, 1],
      repeat: Infinity,
      repeatDelay: 1,
    },
  };

  // PASSWORD SHOW HIDE

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toast = useToast();

  const showToast = (status, message) => {
    toast({
      title: `${status.charAt(0).toUpperCase() + status.slice(1)}`,
      description: message,
      status: status, // Set this to 'error' for a red-colored pop-up
      duration: 3000,
      isClosable: true,
    });
  };

  const clientId = clientid; // Your Google client ID

  // Handle successful login/signup
  const handleSignUpSuccess = (response) => {
    // console.log("Google Sign-Up Success:", response);

    // Send the response token to your backend
    fetch(`${apiEndPoint}firebaseAuth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ googleToken: response.credential }),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log("User registration or sign-in handled", data);
        const a = data.accessToken;
        const b = data.userData;
        const c = data.userData.email;
        // console.log(data.message);
        showToast("success", `${data.message}`);

        // console.log("Accesstoken is", a, "User data is", b, "Email is", c);

        sessionStorage.setItem("userData", JSON.stringify(b));
        sessionStorage.setItem("number", a.toString());
        sessionStorage.setItem("email", c.toString());

        // ✅ Set google auth to true in Redux
      dispatch(setGoogleAuth(true));


        navigate("/Files");
        // Handle user registration in your app (e.g., navigate, store tokens, etc.)
      })
      .catch((error) => {
        // console.error("Error during authentication:", error);
        showToast("error", "Authentication failed. Please try again.");
      });
  };

  // Handle login failure
  const handleFailure = (error) => {
    // console.error("Google Sign-Up Failed:", error);
    showToast("error", "Google Sign-Up Failed. Please try again.");
  };

  // This is for your custom button
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      // console.log("Google Login Success:", tokenResponse);

      // If you're using the implicit flow, you'll get an access token
      // For Firebase Auth, you likely need to convert this to an ID token
      // or handle it differently depending on your backend implementation

      // Option 1: If your backend expects the same format as handleSignUpSuccess
      if (tokenResponse.access_token) {
        // You might need to adjust this part based on what your backend expects
        fetch(`${apiEndPoint}firebaseAuth`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ googleToken: tokenResponse.access_token }),
        })
          .then((res) => res.json())
          .then((data) => {
            const a = data.accessToken;
            const b = data.userData;
            const c = data.userData.email;

            showToast("success", `${data.message}`);

            sessionStorage.setItem("userData", JSON.stringify(b));
            sessionStorage.setItem("number", a.toString());
            sessionStorage.setItem("email", c.toString());
            navigate("/Files");
          })
          .catch((error) => {
            // console.error("Error during authentication:", error);
            showToast("error", "Authentication failed. Please try again.");
          });
      }
    },
    onError: handleFailure,
    flow: "implicit", // or 'auth-code' depending on your backend setup
  });
  return (
    <>
      <ChakraProvider></ChakraProvider>
      <div className="form_container">
        <div className="login_left_col">
          <div className="login_graphic_text">
            <h2>{slides[currentSlide].title}</h2>
            <p>{slides[currentSlide].text}</p>
          </div>
          <div className="login_graphic">
            <img src={Illustration} className="img_responsive" />
          </div>
        </div>

        <div className="login_content">
          <div className="login_form">
            <div className="logo_login">
              <img src={LogoStolity} alt="logo" style={{height:"50px"}}/>
            </div>
            <h3 className="mt-4">Welcome Back!</h3>
            {/* <div className="btn_google_group">
              <Link to='/' className='login_google ripple_effect'><img src={IconLGoogle} /> Sign in with Google</Link>
              <Link to='/' className='login_other ripple_effect'><img src={IconFacebook} /></Link>
              <Link to='/' className='login_other ripple_effect'><img src={IconApple} /></Link>
            </div>
            <div className='or'>
              <span>OR</span>
            </div> */}
            <form onSubmit={handleSubmit}>
              <div className="mt-4">
                <div className="form_group">
                  <label className="login_label">Email address</label>
                  <input
                    type="email"
                    className={`form-control form_control ${
                      emailError ? "is-invalid" : ""
                    }`}
                    name="email"
                    placeholder="Enter Email address"
                    value={email}
                    onChange={handleEmail}
                  />
                </div>
                {emailError && (
                  <div className="error-message">{emailError}</div>
                )}
                <div className="form_group">
                  <label className="login_label">Password</label>

                  <div className="text_field">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control form_control"
                      placeholder="Enter your Password"
                      value={password}
                      onChange={handlePass}
                    />

                    {/* ✅ Eye icon always visible */}
                    <div
                      className="icon_field"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <PasswordShow /> : <PasswordHide />}
                    </div>
                  </div>

                  {/* ✅ Show error message only, no border/icon */}
                  {passwordError && (
                    <div className="error-message">{passwordError}</div>
                  )}
                </div>

                <div className="group_flexend mt-2">
                  <div className="radio-buttons custom_radio_btn">
                    <input type="checkbox" id="Remember" />
                    <label htmlFor="Remember">Remember me</label>
                  </div>
                </div>
                <div className="btn_login_group">
                  <button
                    type="submit"
                    className={`btn_login ripple_effect ${
                      buttonClicked ? "btn--clicked" : ""
                    }`}
                  >
                    Login
                  </button>
                </div>
                {error && <div className="text-red-500 mt-3">{error}</div>}
                <div class="divider">
                  <span>OR</span>
                </div>
                <GoogleOAuthProvider clientId={clientId}>
                  <div style={{ marginTop: "10px", justifySelf: "center" }}>
                    <GoogleLogin
                      onSuccess={handleSignUpSuccess}
                      onError={handleFailure}
                      text="signup_with" // Changes the button text to "Sign up with Google"
                      shape="rectangular" // Customize the button shape
                      theme="filled_blue" // Customize button theme (e.g., outline, filled)
                      size="large" // Size of the button (small, medium, large)
                      width="250" // Optional width for the button
                    />
                  </div>
                </GoogleOAuthProvider>
                <div className="have_acc mt-3">
                  Don’t have an Account?{" "}
                  <Link to="/Signup" style={{ color: "#E94545" }}>
                    Sign up
                  </Link>
                </div>

                {/* <div class="divider">
                  <span>OR</span>
                </div> */}

                {/* <div class="social-container">
                  <div class="social-button">
                    <img src={FA} alt="Facebook" />
                  </div>
                  <GoogleOAuthProvider clientId={clientId}>
        <div 
          className="social-button" 
          onClick={() => login()}
          role="button"
          aria-label="Sign in with Google"
        >
          <img src={GOO} alt="Google" />
        </div>
      </GoogleOAuthProvider>
                  <div class="social-button">
                    <img src={APL} alt="Apple" />
                  </div>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>

      <span
        className={`animate_logo animate_logo_loader ${
          spanExpanded ? "expanded" : ""
        }`}
        data-value="1"
        style={{
          background: `conic-gradient(from 0deg at 50% 50%, #E5252A 0deg, #E7400C 120deg, #FFAB49 240deg, #E5252A 360deg)`,
          // display: 'flex',
          // alignItems: 'center',
          // justifyContent: 'center'
        }}
      >
        <div className="logo__load" style={{width:"100px", height:"100px"}}>
          <motion.img
            src={NewLogo}
            alt="Logo"
            style={{
              width: "90px",
              height: "90px",
              filter: "brightness(0) invert(1)"
            }}
            animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 360],
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeat: Infinity,
              repeatDelay: 1,
            }}
          />
        </div>
      </span>
    </>
  );
};

export default Login;
